import axios from "axios";
import authHeader from "./auth-header";

const INTERCOM_APP_ID = "xnlcqw00";

let intercomLoaded = false;
let intercomBooted = false;

function loadIntercomWidget() {
  if (intercomLoaded) return;
  intercomLoaded = true;

  const w = window;
  const ic = w.Intercom;
  if (typeof ic === "function") {
    ic("reattach_activator");
    ic("update", w.intercomSettings);
  } else {
    const i = function () { i.c(arguments); };
    i.q = [];
    i.c = function (args) { i.q.push(args); };
    w.Intercom = i;

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
    const x = document.getElementsByTagName("script")[0];
    x.parentNode.insertBefore(s, x);
  }
}

async function fetchHelpdeskToken() {
  const headers = authHeader();
  if (!headers) return null;

  try {
    const response = await axios.post(
      window.config.API_URL + "helpdesk_token",
      {},
      { headers }
    );
    return response.data?.data?.token || response.data?.token || response.data;
  } catch (error) {
    console.error("Failed to fetch helpdesk token:", error);
    return null;
  }
}

async function bootIntercom() {
  if (intercomBooted) return;

  const reduxState = JSON.parse(localStorage.getItem("reduxState"));
  const metaData = JSON.parse(localStorage.getItem("metaData"));

  if (!reduxState?.auth) return;
  if (metaData?.ra_support === false) return;

  const jwt = await fetchHelpdeskToken();
  if (!jwt) return;

  const clientId = metaData?.client_id || localStorage.getItem("client_id") || "";
  const clientName = metaData?.client_name || localStorage.getItem("client_name") || "";

  loadIntercomWidget();

  window.Intercom("boot", {
    api_base: "https://api-iam.intercom.io",
    app_id: INTERCOM_APP_ID,
    user_id: reduxState.auth.email,
    email: reduxState.auth.email,
    intercom_user_jwt: jwt,
    session_duration: 86400000,
    company: {
      company_id: clientId,
      name: clientName,
    },
  });

  intercomBooted = true;
}

function shutdownIntercom() {
  if (window.Intercom) {
    window.Intercom("shutdown");
  }
  intercomBooted = false;
}

const IntercomService = { bootIntercom, shutdownIntercom };
export default IntercomService;
